import React, {useEffect, useState} from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'
import { mttAjax } from 'utils/_mtt_ajax'

function Inputs(props){
  const [strings] = useEnvValue('strings')
  const [zipCode,setZipCode] = useEnvValue('planting.zipCode','')
  const [plantingPrice,setPlantingPrice] = useEnvValue('planting.price',0)
  const [price,setPrice] = React.useState('')

  const [loading,setLoading] = React.useState(false)
  const [selectedVariation] = useEnvValue('selectedVariation',null)
  const [selectedQuantity] = useEnvValue('selectedQuantity')

  const handleOnChange = function(e){
    let zip = e.target.value
    setZipCode(zip)
  }

  useEffect(() => {
    setLoading(true)
    fetchPriceByZipCode(zipCode)
  }, [zipCode, selectedQuantity])

  const fetchPriceByZipCode = function(zip) {
    if (selectedVariation === null) {
      return
    }

    mttAjax('get_planting_price',{
      action: 'get_planting_price',
      hedge_plant_postal:zip,
      variant_id:selectedVariation.id,
      quantity:selectedQuantity,
    },onFetchPriceByZipCodeCallback)
  }
  const onFetchPriceByZipCodeCallback = function(response){
    setLoading(false)
    if(response && response.success === true && typeof response.data === 'object' && response.data.planting_price !== false){
      setPrice(response.data.planting_price)
      setPlantingPrice(response.data.planting_price)
    }else{
      setPrice('')
      setPlantingPrice(0)
    }
  }

  return (
    <>
      <div className="input-wrap">
        <label>
          <span>{strings.planting.writeZipCode}<br/>{strings.planting.whereToPlant}</span>
          <div className="input">
            <input type="number" name="plantingZipCode" value={zipCode} onChange={handleOnChange}/>
          </div>
        </label>
      </div>
      <div className="input-wrap">
        <label>
          <span><br/>{strings.price}</span>
          <div className="input">
            <input type="text" name="plantingPrice" disabled={'disabled'} defaultValue={price}/>
            <p>{strings.priceEnding}</p>
          </div>
        </label>
      </div>
    </>
  )
}

export default observer(Inputs)
